import React from 'react';

export const Cube = ({ width = 20, height = 20, className, style }) => {
  return (
    <svg width={width} height={height} className={className} style={style} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.81567 10.3947L16.1315 6.44737" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 6.44737L9.81579 10.3947V17.5L16.1316 13.5526V6.44737L9.81579 2.5L3.5 6.44737Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 6.44737V13.5526L9.81579 17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
